import { render, staticRenderFns } from "./jianjie.vue?vue&type=template&id=5daf9990&scoped=true"
import script from "./jianjie.vue?vue&type=script&lang=js"
export * from "./jianjie.vue?vue&type=script&lang=js"
import style0 from "./jianjie.vue?vue&type=style&index=0&id=5daf9990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daf9990",
  null
  
)

export default component.exports